import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Input, Select } from '@naf/input';
import { spacing } from '@naf/theme';

const DROPDOWN_MENU_WIDTH = '240px';

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InputRow = styled.div`
  display: flex;
  gap: ${spacing.space8};
  align-items: stretch;
`;

export const CountrySelect = styled(Select)`
  flex: 0 0 ${spacing.space120};
  min-width: 0;

  /* Override the absolutely-positioned dropdown menu so it stays readable
     even though the Select input itself is narrow. Relies on @naf/input
     Select's internal styled-component using \`displayName: 'select__ListContainer'\`. */
  [class*='ListContainer'] {
    width: ${DROPDOWN_MENU_WIDTH};
  }

  /* When disabled, hide the clear (✕) button and the expand chevron (⌄) so the field reads as
     read-only — only the dial code stays visible. @naf/input Select names these via
     \`displayName: 'select__ClearButton'\` / \`'select__ExpandButton'\`. */
  ${({ disabled }) =>
    disabled &&
    css`
      [class*='ClearButton'],
      [class*='ExpandButton'] {
        display: none;
      }
    `}
`;

export const PhoneNumberInput = styled(Input)`
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
`;
